module.exports = __webpack_public_path__ + "img/mobile-home-call-btn.df57da9c.svg";